import React, { useState, useEffect } from "react";
import { changeSessionTime } from "../../services/adminTimeTableServices";
import { extractLocalTime, buildLocalDateTime } from "../../../utils/dateTimeUtils";

const inputStyle = {
 width: "100%",
 padding: "8px",
 marginBottom: "12px",
};

const ChangeSessionTimeModal = ({ session, dayDate, onClose, reload }) => {
 const [startClock, setStartClock] = useState("");
 const [endClock, setEndClock] = useState("");
 const [loading, setLoading] = useState(false);

 useEffect(() => {
 if (session) {
 setStartClock(extractLocalTime(session.startTime));
 setEndClock(extractLocalTime(session.endTime));
 }
 }, [session]);

 const handleSubmit = async () => {
 if (!startClock || !endClock) {
 alert("Please provide start and end time");
 return;
 }

 setLoading(true);
 try {
 await changeSessionTime(
 session.id,
 buildLocalDateTime(dayDate, startClock),
 buildLocalDateTime(dayDate, endClock)
 );
 alert("Session time updated successfully!");
 reload();
 onClose();
 } catch (err) {
 // alert(err.response?.data?.message || "Failed to update session time");
 } finally {
 setLoading(false);
 }
 };

 return (
 <div
 style={{
 position: "fixed",
 inset: 0,
 background: "rgba(0,0,0,0.5)",
 display: "flex",
 justifyContent: "center",
 alignItems: "center",
 zIndex: 1000,
 }}
 onClick={onClose}
 >
 <div
 style={{
 background: "#fff",
 padding: "20px",
 borderRadius: "8px",
 width: "300px",
 }}
 onClick={(e) => e.stopPropagation()}
 >
 <h3>Change Session Time</h3>

 {/* Time */}
 <input
 type="time"
 style={inputStyle}
 value={startClock}
 onChange={(e) => {
 const start = e.target.value;
 setStartClock(start);

 const [h, m] = start.split(":").map(Number);
 const end = new Date(0, 0, 0, h, m + 30);

 setEndClock(
 `${String(end.getHours()).padStart(2, "0")}:${String(
 end.getMinutes()
 ).padStart(2, "0")}`
 );
 }}
 />

 <input
 type="time"
 style={inputStyle}
 value={endClock}
 onChange={(e) => setEndClock(e.target.value)}
 />

 {/* Actions */}
 <div style={{ textAlign: "right" }}>
 <button onClick={handleSubmit} disabled={loading} style={{ marginRight: "10px" }}>
 {loading ? "Updating..." : "Update"}
 </button>
 <button onClick={onClose}>Cancel</button>
 </div>
 </div>
 </div>
 );
};

export default ChangeSessionTimeModal;
